var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}));
}

Plus.defaultProps = {"stroke":"currentColor","fill":"currentColor","strokeWidth":"0","viewBox":"0 0 24 24","aria-hidden":"true","className":"css-sm8dfn","height":"1em","width":"1em"};

module.exports = Plus;

Plus.default = Plus;
